import axios from 'axios';

const api = {
  async getEmailConfiguration() {
    const response = await axios.get(`/email/configuration`);
    return response.data;
  },

  async saveEmailConfiguration(newConfig) {
    const response = await axios.patch(`/email/configuration`, newConfig);
    return response.data;
  },
};

export default api;
